import classNames from "classnames/bind";
import { isObject } from "es-toolkit/compat";
import React from "react";
import { useDropdownContext } from "../DropdownContext";
import styles from "../DropdownInput.module.scss";
import DropdownChip from "./DropdownChip";

const cx = classNames.bind(styles);

const DropdownValue = () => {
  const {
    isLoading,
    getLabel,
    getValue,
    isMulti,
    value,
    hasValue,
    data,
    placeholder,
    isMultiValue,
    hasGroups,
    shouldWrap,
  } = useDropdownContext();

  const selectedSlotLeft = data?.selected?.slotLeft;

  const visibleValuesLimit = 5;
  const showPlaceholder =
    (!isLoading && !hasValue) ||
    (hasGroups &&
      (value?.[1] === "" ||
        (Array.isArray(value?.[1]) && value?.[1].length === 0)));

  return (
    <div
      className={cx("valueContainer", {
        isMulti,
        singleValue: !isMulti,
        shouldWrap,
        placeholder: showPlaceholder,
      })}
      data-testid="value"
    >
      {!showPlaceholder && isMulti && isMultiValue(hasGroups, value) ? (
        <>
          {data.selected?.slice(0, visibleValuesLimit).map((chipValue: any) => {
            return (
              <DropdownChip
                key={isObject(chipValue) ? getValue(chipValue) : chipValue}
                chipValue={chipValue}
              />
            );
          })}
          {data.selected?.length > visibleValuesLimit ? (
            <DropdownChip
              key="more-options-selected"
              chipValue={`+${data.selected?.length - visibleValuesLimit} more`}
            />
          ) : null}
        </>
      ) : showPlaceholder ? (
        placeholder
      ) : (
        <div
          className={cx("singleValue", {
            hasSlot: selectedSlotLeft,
          })}
        >
          {selectedSlotLeft}
          {getLabel?.(data?.selected)}
        </div>
      )}
    </div>
  );
};

export default DropdownValue;
